/* Recommendations never block the product response or initial image load. */
(function () {
  function init(scope) {
    scope.querySelectorAll('.sf-style-recommendations').forEach(function (row) {
      if (row.dataset.recommendBound) return;
      row.dataset.recommendBound = 'true';
      async function load() {
        row.dataset.recommendState = 'loading';
        var controller = new AbortController();
        var timeout = setTimeout(function () { controller.abort(); }, 15000);
        try {
          var url = new URL(row.querySelector('.sf-browse-style').href);
          url.searchParams.set('section_id', 'sf-recommendation-cards');
          url.searchParams.set('filter.v.availability', '1');
          var preview = new URL(location.href).searchParams.get('preview_theme_id');
          if (preview) url.searchParams.set('preview_theme_id', preview);
          var response = await fetch(url.href, { signal: controller.signal });
          if (!response.ok) throw new Error('Recommendations unavailable');
          var doc = new DOMParser().parseFromString(await response.text(), 'text/html');
          if (!row.isConnected) return;
          var seen = new Set();
          if (row.dataset.currentSet) seen.add('set:' + row.dataset.currentSet);
          var cards = row.querySelector('[data-recommend-cards]');
          doc.querySelectorAll('[data-recommend-product]').forEach(function (item) {
            var key = item.dataset.recommendSet ? 'set:' + item.dataset.recommendSet : 'product:' + item.dataset.recommendProduct;
            if (cards.children.length >= 4 || seen.has(key) || item.dataset.recommendProduct === row.dataset.currentProduct || item.dataset.recommendStyle !== row.dataset.recommendStyle) return;
            var card = item.querySelector('.pcard');
            if (!card) return;
            seen.add(key);
            cards.appendChild(card);
          });
          cards.hidden = !cards.children.length;
          if (window.sfCards) window.sfCards.init(cards);
          cards.querySelectorAll('.reveal').forEach(function (card) { card.classList.add('in'); });
          row.dataset.recommendState = cards.children.length ? 'ready' : 'empty';
        } catch (error) {
          // Keep the ordinary collection link available on timeout/network failure.
          row.dataset.recommendState = 'unavailable';
        } finally {
          clearTimeout(timeout);
        }
      }
      if ('IntersectionObserver' in window) {
        var observer = new IntersectionObserver(function (entries) {
          if (entries.some(function (entry) { return entry.isIntersecting; })) {
            observer.disconnect();
            load();
          }
        }, { rootMargin: '600px 0px' });
        observer.observe(row);
      } else if (document.readyState === 'complete') load();
      else window.addEventListener('load', load, { once: true });
    });
  }
  init(document);
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
